(() => {
  function init(root=document) {
    root.querySelectorAll('.journey-colors:not([data-ready])').forEach(controls => {
      controls.dataset.ready='true';
      const hero=controls.closest('.journey-hero');
      controls.querySelectorAll('[data-suit-image]').forEach(button => {
        button.addEventListener('click',() => {
          controls.querySelectorAll('[data-suit-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
          hero.querySelectorAll('.journey-figure').forEach(figure=>figure.style.backgroundImage=`url("${button.dataset.suitImage}")`);
          controls.querySelector('.journey-style-label').textContent=button.dataset.suitLabel;
        });
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
